module.exports = __webpack_public_path__ + "static/media/tire-flat.db73f9de.svg";